<template>
  <section class="report-section" v-if="show">

    <h4>1.1.2 Fabbisogno Energetico Termico</h4>

    <table class="grid">
      <tr>
        <td class="col-small">
          <div class="pie-wrap">
            <apexchart type="pie" :options="pie1_options" :series="pie1_data"></apexchart>
          </div>
        </td>
        <td>
          <b-table :items="table1" :fields="fields">
            <template slot="color" slot-scope="row">
              <span class="legend" :style="{ color: $store.state.colors[row.index] }">■</span>
            </template>
            <template slot="TEP" slot-scope="row">
              {{ f(row.item.TEP) }}
            </template>
            <template slot="value" slot-scope="row">
              {{ f(row.item.value) }}
            </template>
            <template slot="cost" slot-scope="row">
              {{ f(row.item.cost) }}
            </template>
          </b-table>
        </td>
      </tr>
    </table>

  </section>
</template>

<script>
export default {
  name: "FabbisognoTermico",

  props: ['tep'],
  data() {
    return {
      show: true,
      vectors: {},
      table1: [],
      pieOptions: {
        colors: this.$store.state.colors,
        chart: {
          animations: {
            enabled: false
          }
        },
        labels: [],
        tooltip: {
          y: {
            formatter: v => {
              return v ? this.f(v) + " [kWh]" : ""
            }
          }
        },
        legend: {
          show: false
        }
      },
      pie1_options: {},
      pie1_data: [],
      fields: [
        { key: 'color', label: '' },
        { key: 'name', label: 'Canale' },
        { key: 'value', label: 'Consumo' },
        { key: 'mu', label: 'U.M.' },
        { key: 'perc', label: '%' },
        { key: 'TEP', label: 'TEP' },
        { key: 'cost', label: '€' }
      ]
    }
  },

  created() {
    this.reload()
  },

  methods: {
    f(v) {
      return this.$options.filters.formatDecimal(v)
    },
    reload() {

      var total = 0
      let pie1_options = _.cloneDeep(this.pieOptions)

      var termicVectors = ['gas', 'metano', 'gpl']

      this.table1 = []
      this.pie1_data = []

      this.tep.forEach(item => {

        if(! _.includes(termicVectors, item.vector))
            return

        item.mu = this.$store.state.vectors.list.find(vv => vv.code == item.vector).mu
        item.perc = 0
        this.table1.push(item)
        this.pie1_data.push(item.value)
        pie1_options.labels.push(item.name)
      })

      this.pie1_options = pie1_options
      if(this.pie1_data.length == 0)
        this.show = false
    },
  },
  watch: {
    tep() {
      this.reload()
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Report/C_FabbisognoTermico.vue